<template>
  <li>
    <div class="d-flex justify-content-between">
      <div class="main">
        <span class="ske">{{ site }}</span>
      </div>
      <span class="ske">
        {{ formattedDate }}
      </span>
    </div>
    <div class="info">
      <span class="ske">
        Hoeveelheid: {{ orderAmount }}
      </span>
      <span class="ske ml-1">
        Nummer: {{ orderAmount }}
      </span>
    </div>
  </li>
</template>

<script>

/*

customer: "Fatiha Aoulad m'hand"
email: "2rqijzezbwplemoeluzc2kgjxpz3ju@verkopen.bol.com"
orderAmount: 7.97
orderDate: "2021-12-05T20:28:56.000Z"
orderNumber: "1299347350"
orders: Array(1)
site: "bol.com"
state: "SHIPPED"
uid: "ff46094c-fb1e-42fb-ac3d-b0a14801eb77"

*/

import { format } from 'date-fns'

export default {
  props: {
    state: String,
    orderAmount: Number,
    orderNumber: String,
    orderDate: String,
    site: String,

    uid: String,
  },
  computed: {
    formattedDate() {
      const date = this.orderDate

      try {
        return date && format(new Date(date), "dd-MM-yyyy HH:mm")
      } catch (err) {
        return date
      }
    },
  },
}

</script>

<style scoped>

.main {
  font-weight: 600;
  font-size: 0.9375em;
}

.info {
  font-size: 0.75em;
  margin-top: -3px;
}

li {
  padding: 10px 0;
}

li + li {
  border-top: 1px solid #EFEFF0;
}

</style>
